import { render } from "./Default.vue?vue&type=template&id=2e2b7c50"
const script = {}
script.render = render

export default script